/**
 * Fallback authentication methods
 */
export var FallbackMethod;
(function (FallbackMethod) {
    FallbackMethod["PASSCODE"] = "passcode";
    FallbackMethod["PASSWORD"] = "password";
    FallbackMethod["PATTERN"] = "pattern";
    FallbackMethod["PIN"] = "pin";
    FallbackMethod["SECURITY_QUESTION"] = "securityQuestion";
})(FallbackMethod || (FallbackMethod = {}));
//# sourceMappingURL=adapters.js.map